import useSWR from 'swr';
import { getUserInfoUrl } from '../endpoints/user';

export const useGetUserInfo = (shouldFetch: boolean) => {
    const response = useSWR<AuthenticatedUser>(shouldFetch ? getUserInfoUrl : null);
    return response.data;
};
